const MESSAGE = "Only numbers or *";

export default (value: string) => {
  if (value) value = value.replace(",", ".");

  return value && !/^\d+(\.\d{1,5})?$/.test(value) && value.trim() !== "*"
    ? MESSAGE
    : undefined;
};
